import { IMembro } from '@/@types/EstruturaOrganizacional';
import { ContainerMembros } from '@/components/shared/ContainerMembros';
import { Loading } from '@/components/shared/Loading';
import { MembroItem } from '@/components/shared/MembroItem';
import { api } from '@/services/api';
import { useEffect, useState } from 'react';

const ComposicaoCOEX = () => {
    const [composicaoCOEX, setComposicaoCOEX] = useState<IMembro[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {

        const getComposicaoCOEX = async () => {
            setIsLoading(true);
            const url = '/feagri/colegiados/orgao/sigla/COEX';

            await api.get(url)
                .then(response => {
                    setComposicaoCOEX(response.data);
                })
                .catch(err => {
                    console.log(err)
                })
                .finally(() => setIsLoading(false));

        }

        getComposicaoCOEX();

    }, []);

    return(
        <>
            <h1>Composição da Comissão de Extensão - COEX</h1>

            {isLoading ? (
                <Loading color='primary' />
            ) : (
                <ContainerMembros>
                    {composicaoCOEX.map(representante => {
                        return (
                            <MembroItem key={representante._id} data={{
                                representanteFuncao: representante.funcao.funcaoweb,
                                representanteNome: representante.representante.nome,
                                representanteTitulo: representante.representante.funcao_representante,
                                representanteSubfuncao: representante.subfuncao?.subfuncaoweb,
                                foto: representante.representante.foto
                            }} />
                        );
                    })}
                </ContainerMembros>
            )}
        </>
    );
}

export { ComposicaoCOEX };